import IllumioSupportUtils from "../common/support_utils.js";
import { IllumioGeoLocation } from "../common/geo_location.js";

export class AssetDownload {
    constructor(metadata, asset, acceptanceId) {
        this.metadata = metadata;
        this.asset = asset;
        this.acceptanceId = acceptanceId;
        this.csrfToken = this.retrieveCsrfToken();
    }
    
    retrieveCsrfToken() {
        const csrfTokenElements = document.getElementsByName('csrf-token');
        if (csrfTokenElements.length>0 && csrfTokenElements[0].tagName==='META' && csrfTokenElements[0].content) {
            return csrfTokenElements[0].content;
        } else {
            console.warn('AssetDownload: retrieveCsrfToken(): Unable to retreive csrf token from the meta tags!');
        }
        
        return null;
    }
    
    getDownloadForm() {
        const fields = {
            'asset_id': this.asset.id,
            'eula_acceptance_id': this.acceptanceId,
            'download_type': this.metadata.type,
            'authenticity_token': this.csrfToken,
            'download_zip' : (this.downloadZip) ? true : false,
        }
        const fieldNames = Object.keys(fields);
        
        let formElement = document.getElementById('downloadForm');
        let fieldNamesForEachHandler = null
        if (formElement) {
            fieldNamesForEachHandler = function(fieldName) {
                formElement[fieldName].value = fields[fieldName];
            }
        } else {
            formElement = document.createElement('form');
            formElement.id = 'downloadForm';
            formElement.href = '/software/download';
            formElement.action = 'post';
            fieldNamesForEachHandler = function(fieldName) {
                formElement.appendChild(IllumioDomUtils.createInputTag('hidden', 'fieldName', fields[fieldName]));
            }
            
            if (IllumioGeoLocation && IllumioGeoLocation.currentPosition && formElment) {
                const latitudeInput = IllumioDomUtils.createInputTag('hidden', 'geolocation[latitude]', IllumioGeoLocation.currentPosition.coords.latitude);
                const longitudeInput = IllumioDomUtils.createInputTag('hidden', 'geolocation[longitude]', IllumioGeoLocation.currentPosition.coords.longitude);
                if (latitudeInput && longitudeInput) {
                    formElment.appendChild(latitudeInput);
                    formElment.appendChild(longitudeInput);
                }
            }
            
            // Append the form to the body tag
            const bodyElements = document.getElementsByTagName;
            if (bodyElements.length>0) {
                bodyElements[0].appendChild(bodyElements[0]);
            }
        }
        fieldNames.forEach(fieldNamesForEachHandler);
        
        return formElement;
    }
    
        download() {
            const downloadFormElement = this.getDownloadForm();
            console.debug(downloadFormElement);
            
            downloadFormElement.submit();
            console.debug(`AssetDownload: download(): Tracking » ${this.metadata.product} » ${this.metadata.type} » ${this.asset.version}|${this.asset.name}`);
            IllumioSupportUtils.trackGaEvent(this.metadata.product, this.metadata.type, this.asset.version+'|'+this.asset.name); 
        }
        
        setDownloadZip(downloadZip) {
            this.downloadZip = downloadZip;
        }
}